import groupTypes from "../config/groupTypes";
import layoutTypes from "../config/layoutTypes";

export default function getLayoutType({ groupBy }) {
  if ([groupTypes.groups, groupTypes.userGroup, groupTypes.masterGroup].includes(groupBy)) return layoutTypes.groups;
  if (groupBy === groupTypes.all) return layoutTypes.contacts;
}
